import React from 'react';
import './App.css';
import { AuthProvider } from './components/AuthProvider';
import MobileRoot from './mobile/MobileRoot';
import DesktopRoot from './components/DesktopRoot';
import { useIsMobile } from './hooks/useIsMobile';

// Main App Component with Mobile/Desktop Detection
function AppContent() {
  const isMobile = useIsMobile();
  
  // Check if we should force mobile mode (for mobile operations)
  const forceMobile = sessionStorage.getItem('forceMobile') === 'true';
  const shouldShowMobile = isMobile || forceMobile;

  return shouldShowMobile ? <MobileRoot /> : <DesktopRoot />;
}

// Root App with Providers
function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;